/**
 * Generated from IntroScreenLayout.fla
 */
/* tslint:disable */
function $(e:any,t:number|string,o:number[]|{():any},a?:any){if("object"==typeof o)e[t]=o;else{"number"==typeof t&&!e[t]&&e.elementFactory&&(e[t]=e.elementFactory(t,a)),e=e[t],o.call(e);for(const t in a)a.hasOwnProperty(t)&&("w"===t?e.width=a[t]:"h"===t?e.height=a[t]:"sx"===t&&e.scale?e.scale.x=a[t]:"sy"===t&&e.scale?e.scale.y=a[t]:"r"===t?e.rotation=a[t]:e[t]=a[t]);e.onLayout&&e.onLayout()}}
export default function IntroScreenLayout(this: $IntroScreenLayout) {
	$(this, "main", main, {x:1024, y:768});
	return this;
}
export function main(this: $main) {
	const earth = this.earth;
	$(earth, 0, earth1, {x:17.15, y:-160.3, w:1100.00, h: 1103.00});
	$(earth, 1, earth2, {x:17.15, y:-160.3, w:1100.00, h: 1103.00});
	$(earth, 2, earth3, {x:17.15, y:-160.3, w:1100.00, h: 1103.00});
	$(this, "background", background, {x:-1664, y:-768, w:3328.80, h: 1536.00});
	$(this, "characters", characters, {x:588.05, y:506.15, w:909.00, h: 632.00});
	$(this, "boxes", boxes, {x:-50.8, y:657.8, w:557.00, h: 442.00});
	$(this, "luna", luna, {x:-563.35, y:872.1, w:862.27, h: 883.95});
	$(this, "buttonNext", buttonNext, {x:-8.35, y:529.3, w:349.00, h: 357.00});
	return this;
}
function background(this: $background) {
	if (this.setLayoutTexture) this.setLayoutTexture("intro.jpg", 0.000, 0.000);
	return this;
}
function earth1(this: $earth1) {
	if (this.setLayoutTexture) this.setLayoutTexture("earth-1.png", 0.500, 0.500);
	return this;
}
function earth2(this: $earth2) {
	if (this.setLayoutTexture) this.setLayoutTexture("earth-2.png", 0.500, 0.500);
	return this;
}
function earth3(this: $earth3) {
	if (this.setLayoutTexture) this.setLayoutTexture("earth-3.png", 0.500, 0.500);
	return this;
}
function characters(this: $characters) {
	if (this.setLayoutTexture) this.setLayoutTexture("characters.png", 0.501, 0.500);
	return this;
}
function boxes(this: $boxes) {
	if (this.setLayoutTexture) this.setLayoutTexture("boxes.png", 0.501, 0.500);
	return this;
}
function luna(this: $luna) {
	if (this.setLayoutTexture) this.setLayoutTexture("luna.png", 0.590, 0.999);
	return this;
}
function buttonNext(this: $buttonNext) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-go.png", 0.501, 0.501);
	return this;
}
interface $$array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface $$container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface $$sprite extends $$container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface $$text extends $$container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface $$polygon extends Array<number> {
}
interface $IntroScreenLayout {
	readonly main: $main;
}
interface $main extends $$container {
	readonly earth: $$array<$earth1|$earth2|$earth3>;
	readonly background: $background;
	readonly characters: $characters;
	readonly boxes: $boxes;
	readonly luna: $luna;
	readonly buttonNext: $buttonNext;
}
interface $background extends $$sprite {
}
interface $earth1 extends $$sprite {
}
interface $earth2 extends $$sprite {
}
interface $earth3 extends $$sprite {
}
interface $characters extends $$sprite {
}
interface $boxes extends $$sprite {
}
interface $luna extends $$sprite {
}
interface $buttonNext extends $$sprite {
}
